"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _FullCalendar = _interopRequireDefault(require("rc-calendar/lib/FullCalendar"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledCalendar = require("./StyledCalendar");
var _Select = _interopRequireDefault(require("../Select"));
var _LocaleContext = require("../locales/LocaleContext");
var _default = _interopRequireDefault(require("../locales/default"));
require("moment/locale/tr");
var _moment = _interopRequireDefault(require("moment"));
var _CardCalendar = _interopRequireDefault(require("./CardCalendar/CardCalendar"));
var _excluded = ["children"],
  _excluded2 = ["fullscreen", "prefixCls", "height", "events", "type", "footer", "customDates", "width", "borderless", "onSelect"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function noop(params) {
  var children = params.children,
    rest = (0, _objectWithoutProperties2.default)(params, _excluded);
  var prefixCls = rest.className.split('-')[0];
  return /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({}, rest, {
    prefixCls: prefixCls
  }), children.map(function (child) {
    return /*#__PURE__*/_react.default.createElement(_Select.default.Option, {
      key: child.key,
      value: child.key
    }, child.props.children);
  }));
}
var Calendar = exports.default = /*#__PURE__*/function (_Component) {
  function Calendar() {
    var _this;
    (0, _classCallCheck2.default)(this, Calendar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Calendar, [].concat(args));
    (0, _defineProperty2.default)(_this, "oneDay", 24 * 3600 * 1000);
    return _this;
  }
  (0, _inherits2.default)(Calendar, _Component);
  return (0, _createClass2.default)(Calendar, [{
    key: "getDays",
    value: function getDays() {
      var days = [];
      for (var i = 0; i < 7; i++) {
        days.push(this.formatDay(new Date(Date.now() + i * this.oneDay)));
      }
      return days;
    }
  }, {
    key: "formatDay",
    value: function formatDay(day) {
      return day.getDate() + '.' + (day.getMonth() + 1);
    }
  }, {
    key: "calculateEvents",
    value: function calculateEvents(items) {
      if (items && items.length > 0) {
        return Object.groupBy(items, function (_ref) {
          var hour = _ref.hour;
          return hour;
        });
      } else {
        return {};
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        fullscreen = _this$props.fullscreen,
        prefixCls = _this$props.prefixCls,
        height = _this$props.height,
        events = _this$props.events,
        type = _this$props.type,
        footer = _this$props.footer,
        customDates = _this$props.customDates,
        width = _this$props.width,
        borderless = _this$props.borderless,
        onSelect = _this$props.onSelect,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded2);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return !events ? /*#__PURE__*/_react.default.createElement(_StyledCalendar.StyledCalendarContainer, {
          theme: theme,
          fullscreen: fullscreen,
          prefixCls: prefixCls
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
            componentName: "Calendar",
            defaultLocale: type === 'card' ? _default.default.DatePicker : _default.default.Calendar
          }, function (localeCode, locale) {
            return type === 'card' ? /*#__PURE__*/_react.default.createElement(_CardCalendar.default, {
              theme: theme,
              footer: footer,
              prefixCls: prefixCls,
              locale: locale,
              customDates: customDates,
              width: width,
              borderless: borderless,
              onSelect: onSelect
            }) : /*#__PURE__*/_react.default.createElement(_FullCalendar.default, (0, _extends2.default)({
              Select: noop,
              prefixCls: styledPrefix,
              fullscreen: fullscreen,
              locale: locale
            }, rest));
          });
        }) : /*#__PURE__*/_react.default.createElement(_StyledCalendar.StyledCalendarWeekly, (0, _extends2.default)({
          theme: theme,
          prefixCls: prefixCls
        }, rest), _this2.getDays().map(function (tdd, index) {
          var _events$index;
          return /*#__PURE__*/_react.default.createElement(_StyledCalendar.StyledCalendarWeeklyItem, {
            key: index,
            $height: height
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "date"
          }, events[index].date ? events[index].date : tdd), /*#__PURE__*/_react.default.createElement("div", null, Object.entries(_this2.calculateEvents((_events$index = events[index]) === null || _events$index === void 0 ? void 0 : _events$index.list)).map(function (event, itemIndex) {
            var hourText = (0, _moment.default)(event[0]).format('hh:mm');
            var eventList = event[1];
            return /*#__PURE__*/_react.default.createElement("div", {
              key: itemIndex
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "hour"
            }, /*#__PURE__*/_react.default.createElement(Icon, {
              name: "clock",
              size: "20",
              colorType: "primary"
            }), /*#__PURE__*/_react.default.createElement("span", {
              className: "hour-text"
            }, hourText)), /*#__PURE__*/_react.default.createElement("ul", null, eventList.map(function (item, j) {
              return /*#__PURE__*/_react.default.createElement("li", {
                key: j
              }, item.context);
            })));
          })));
        }));
      });
    }
  }]);
}(_react.Component);
Calendar.propTypes = {
  type: _propTypes.default.oneOf(['regular', 'card']),
  fullscreen: _propTypes.default.bool,
  weeklyCalendarHeight: _propTypes.default.string,
  events: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    hour: _propTypes.default.Date,
    context: _propTypes.default.string.isRequired
  })])),
  /** 
  Need only when type="card"
  */
  customDates: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    date: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.object), _propTypes.default.object])
  })),
  /** 
  Works only when type="card"
  */
  width: _propTypes.default.string,
  /** 
  Works only when type="card"
  */
  footer: _propTypes.default.node,
  /** 
  Works only when type="card"
  */
  borderless: _propTypes.default.bool,
  /** 
  Works only when type="card"
  */
  onSelect: _propTypes.default.func
};
Calendar.defaultProps = {
  fullscreen: true,
  type: 'regular',
  borderless: false
};